var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustomerSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "customer-support_svg__icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M790.5 558.9c-11 0-20 9-20 20v33.6c0 40.5-15.9 78.6-44.7 107.5-28.8 28.8-67 44.7-107.5 44.7h-27.8c-8-20.5-27.9-35-51.2-35-30.4 0-55 24.6-55 55s24.6 55 55 55c23.3 0 43.2-14.5 51.2-35h27.8c51.1 0 99.4-20 135.7-56.4s56.4-84.6 56.4-135.7V579c0.1-11.1-8.9-20.1-19.9-20.1zM820.5 393.5h-60c0-66.4-25.8-128.8-72.8-175.7-46.9-47-109.3-72.8-175.7-72.8s-128.8 25.8-175.7 72.8c-46.9 46.9-72.8 109.3-72.8 175.7h-60c0-82.4 32.1-159.9 90.4-218.1S429.6 85 512 85s159.9 32.1 218.1 90.4 90.4 135.7 90.4 218.1z",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M239.8 678.2c-54.5 0-99.1-44.6-99.1-99.1V455.5c0-54.5 44.6-99.1 99.1-99.1 54.5 0 99.1 44.6 99.1 99.1v123.6c0 54.5-44.6 99.1-99.1 99.1zM784.2 678.2c-54.5 0-99.1-44.6-99.1-99.1V455.5c0-54.5 44.6-99.1 99.1-99.1 54.5 0 99.1 44.6 99.1 99.1v123.6c0 54.5-44.6 99.1-99.1 99.1zM539.5 784.7m-21.7 0a21.7 21.7 0 1043.4 0 21.7 21.7 0 10-43.4 0z",
    fill: "#707070"
  })));
}

export default SvgCustomerSupport;